import { Pipe, PipeTransform } from '@angular/core';
import { AuthService } from '../services/auth.service';

interface ArgsMoneyPipe {
  needSymbol?: boolean;
}

@Pipe({
  name: 'money',
})
export class MoneyPipe implements PipeTransform {

  constructor(
    private _AuthService: AuthService
  ) { }

  transform(value: number, args: ArgsMoneyPipe = {}): string {
    let valueRed = value.toLocaleString('es-ES', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    if (valueRed.length === 7 && value > 0) {
      valueRed = valueRed.substring(0, 1) + '.' + valueRed.substring(1);
    }
    if (valueRed.length === 8 && value < 0) {
      valueRed = valueRed.substring(0, 2) + '.' + valueRed.substring(2);
    }

    if (args.needSymbol) {
      const symbol = this._AuthService.currency();
      const currAlignment = this._AuthService.alignmentCurrency();
      valueRed = currAlignment == "RIGHT" ? valueRed + ' ' + symbol : symbol + ' ' + valueRed
    }
    return valueRed;
  }
}
